/**
 * Kept as a re-export so the pre-existing product-image upload path keeps
 * compiling against `ImageStorageAdapter`/`IMAGE_STORAGE_ADAPTER` while the
 * media stack moves to the wider `StorageAdapter` in ./storage.
 *
 * New code should import from './storage/storage-adapter' directly.
 */
export {
  IMAGE_STORAGE_ADAPTER,
  type ImageStorageAdapter,
  type SaveResult,
} from './storage/storage-adapter';
